(() => {
  'use strict';

  const WRAPPER = '[data-mml-cart-consent]';
  const CHECKBOX = '[data-mml-cart-consent-checkbox]';
  const ERROR = '[data-mml-cart-consent-error]';
  const CHECKOUT = 'button[name="checkout"], .cart-button-checkout';
  const FAST_CHECKOUT = '.additional-checkout-buttons, .cart-additional-buttons';
  let consentGranted = false;
  let scheduled = false;

  function cartForms() {
    return [...document.querySelectorAll('form.cart-form, form.cart-drawer-form')];
  }

  function legalText(element) {
    return (element?.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function looksLikeLegacyConsent(element) {
    const text = legalText(element);
    return text.includes('agb') && text.includes('datenschutzerkl');
  }

  function findLegacyEntries(form) {
    const entries = [];

    form.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      if (checkbox.closest(WRAPPER)) return;

      let node = checkbox.closest('label') || checkbox.parentElement;
      let candidate = null;

      for (let depth = 0; node && node !== form && depth < 6; depth += 1, node = node.parentElement) {
        if (!looksLikeLegacyConsent(node)) continue;
        if (node.querySelector(CHECKOUT)) break;
        if (legalText(node).length > 320) break;
        candidate = node;
        break;
      }

      if (candidate) entries.push({ checkbox, container: candidate });
    });

    return entries;
  }

  function syncAndHideLegacy(form) {
    findLegacyEntries(form).forEach(({ checkbox, container }) => {
      container.classList.add('mml-cart-consent-legacy-hidden');
      container.setAttribute('aria-hidden', 'true');

      if (checkbox.checked !== consentGranted) {
        checkbox.click();
      }
    });
  }

  function setFastCheckout(wrapper, enabled) {
    if (!wrapper) return;
    wrapper.classList.toggle('mml-cart-consent-locked', !enabled);
    if (enabled) {
      wrapper.removeAttribute('inert');
      wrapper.removeAttribute('aria-disabled');
    } else {
      wrapper.setAttribute('inert', '');
      wrapper.setAttribute('aria-disabled', 'true');
    }
  }

  function applyState() {
    document.querySelectorAll(CHECKBOX).forEach((checkbox) => {
      checkbox.checked = consentGranted;
    });

    cartForms().forEach((form) => {
      form.querySelectorAll(CHECKOUT).forEach((button) => {
        button.disabled = !consentGranted;
        button.setAttribute('aria-disabled', String(!consentGranted));
      });

      form.querySelectorAll(FAST_CHECKOUT).forEach((wrapper) => {
        setFastCheckout(wrapper, consentGranted);
      });

      syncAndHideLegacy(form);
    });

    if (consentGranted) {
      document.querySelectorAll(WRAPPER).forEach((wrapper) => {
        wrapper.classList.remove('mml-cart-consent--invalid');
        const error = wrapper.querySelector(ERROR);
        if (error) error.hidden = true;
      });
    }
  }

  function showError(form) {
    const wrapper = form?.querySelector(WRAPPER) || document.querySelector(WRAPPER);
    if (!wrapper) return;

    wrapper.classList.add('mml-cart-consent--invalid');
    const error = wrapper.querySelector(ERROR);
    if (error) error.hidden = false;

    const checkbox = wrapper.querySelector(CHECKBOX);
    checkbox?.focus({ preventScroll: true });
    wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function bindCheckboxes() {
    document.querySelectorAll(CHECKBOX).forEach((checkbox) => {
      if (checkbox.dataset.mmlConsentBound === 'true') return;
      checkbox.dataset.mmlConsentBound = 'true';
      checkbox.checked = consentGranted;
      checkbox.addEventListener('change', () => {
        consentGranted = checkbox.checked;
        applyState();
      });
    });
  }

  function initialize() {
    bindCheckboxes();
    applyState();
  }

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest(CHECKOUT);
    const fastCheckout = event.target.closest(FAST_CHECKOUT);
    if ((!checkout && !fastCheckout) || consentGranted) return;

    const form = event.target.closest('form.cart-form, form.cart-drawer-form');
    event.preventDefault();
    event.stopImmediatePropagation();
    showError(form);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form.cart-form, form.cart-drawer-form')) return;
    if (consentGranted) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    showError(form);
  }, true);

  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      initialize();
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
